import mixins from './mixins';

const breakpoints = {
  mobileS: `max-width: 330px`,
  mobileM: `max-width: 400px`,
  mobileL: `max-width: 480px`,
  tabletS: `max-width: 600px`,
  tabletL: `max-width: 768px`,
  desktopXS: `max-width: 900px`,
  desktopS: `max-width: 1080px`,
  desktopM: `max-width: 1200px`,
  desktopL: `max-width: 1400px`,
};

const colors = {
  navy: '#1a3a6f',
  slate: '#6b8bb8',
  green: '#0099ff',
  lightNavy: '#0d2a5c',
  lightSlate: '#9ba8c4',
};

const fontSizes = {
  xl: '16px',
  lg: '14px',
  md: '12px',
  sm: '10px',
  xs: '8px',
};

const theme = {
  colors,
  fontSizes,
  bp: breakpoints,
  mixins,
};

export default theme;
